<template>
  <div class="article-form">
    <b-field v-if="tagsLoaded && !isPublished">
      <custom-message
        :animated="false"
        type="is-warning"
        has-icon
        icon-size="is-medium"
        class="has-extra-padding"
        v-if="item.tags.length == 0 && canPostGenericArticles"
      >
        Новость будет опубликована для всех пользователей
      </custom-message>
      <custom-message
        :animated="false"
        type="is-warning"
        has-icon
        icon-size="is-medium"
        v-else-if="item.tags.length == 0 && !canPostGenericArticles"
      >
        У вас нет прав на публикацию новостей для всех пользователей. Необходимо
        выбрать хотя бы одну группу пользователей для публикации.
      </custom-message>
      <custom-message
        :animated="false"
        type="is-info"
        has-icon
        icon-size="is-medium"
        class="has-extra-padding"
        v-else
      >
        Новость будет опубликована для ограниченного числа пользователей
      </custom-message>
    </b-field>

    <template v-if="this.availableTags.length > 0 && !this.inMedia">
      <b-field>
        <custom-taginput
          autocomplete
          v-model="item.tags"
          :data="filteredTags"
          :open-on-focus="true"
          field="name"
          icon="account-multiple"
          placeholder="Группы пользователей"
          :type="isPublished ? 'is-primary' : null"
          :loading="!tagsLoaded"
          :disabled="!tagsLoaded"
          :readonly="isPublished"
          :icon-resolver="getTagIcon"
          @typing="getFilteredTags"
          @remove="onTagRemove"
        >
        </custom-taginput>
      </b-field>

      <div v-if="!isPublished && item.tags.length > 0">
        <b-field class="vertical-checkbox has-text-centered">
          <b-checkbox v-model="item.send_email">
            Отправить уведомление на E-Mail
          </b-checkbox>
        </b-field>

        <custom-message
          type="is-warning"
          has-icon
          icon-size="is-medium"
          class="has-extra-padding"
          v-if="item.send_email"
        >
          После публикации новости пользователи получат уведомление
        </custom-message>
      </div>
    </template>

    <hr v-if="!isPublished" />

    <div v-show="tagsLoaded">
      <b-field expanded :message="titleInputMessage" :type="titleInputType">
        <b-input
          v-model="item.title"
          @input="onDebouncedTitleUpdate"
          :disabled="ogTagsLoading"
          placeholder="Название статьи или ссылка"
        />
      </b-field>

      <embed-card v-if="item.og_tags" :og-tags="item.og_tags" />

      <b-field v-else-if="!ogTagsLoading">
        <quill-editor
          :value="item.content"
          @change="(value) => (item.content = value.html)"
          @image-remove="onImageRemove"
          @image-upload="onImageUpload"
          @image-uploading="onImageUploading"
          :editorOptions="editorOptions"
          :content-id="contentId"
        />
      </b-field>
    </div>
  </div>
</template>

<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

import EmbedCard from "../../views/news/app/EmbedCard.vue";
import QuillEditor from "../../QuillEditor.vue";
import Attachments from "../../Attachments";
import CustomTaginput from "../../Taginput.vue";
import CustomMessage from "../../Message.vue";

export default Vue.extend({
  props: {
    preset: Object,
    contentId: String,
  },
  components: {
    EmbedCard,
    QuillEditor,
    Attachments,
    CustomTaginput,
    CustomMessage,
  },
  mixins: [messages, toasts],
  data() {
    return {
      ogTagsLoading: false,
      item: {
        id: null,
        title: "",
        published_at: null,
        content: "",
        category: null,
        tags: [],
        author: null,
        send_email: false,
        has_attachments: false,
        is_url: null,
        og_tags: {},
      },
      editorOptions: {
        placeholder: "Содержание статьи",
      },
      availableTags: [],
      filteredTags: [],
      tagsLoaded: false,
    };
  },
  async created() {
    if (this.preset) {
      this.update(this.preset);
    }

    // Load available tags for this article
    axios.get(`/api/news/${this.item.id}/tags`).then(this.onTagsLoad);
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.onUpdate();
      },
    },
  },
  computed: {
    canPostGenericArticles() {
      return this.$can("post generic articles");
    },
    canPostTaggedArticles() {
      return this.$can("post tagged articles");
    },
    isPublished() {
      return this.item.published_at != null;
    },
    inMedia() {
      return this.item.category == "media";
    },
    titleInputMessage() {
      if (this.inMedia) {
        return 'Публикация "ФМП в СМИ"';
      }

      return null;
    },
    titleInputType() {
      if (this.inMedia) {
        return "is-info";
      }

      return null;
    },
  },
  methods: {
    update(item) {
      this.item.id = item.id;
      this.item.title = item.is_url
        ? this.$_.get(item, "og_tags.url", item.title)
        : item.title;
      this.item.published_at = item.published_at;
      this.item.author = item.author;
      this.item.content = item.content;
      this.item.category = item.category;
      this.item.send_email = item.send_email;
      this.item.has_attachments = item.has_attachments;
      this.item.is_url = item.is_url;
      this.item.og_tags = this.$_.isEmpty(item.og_tags) ? null : item.og_tags;
      this.updateArticleInMediaFlag();
    },
    onUpdate() {
      this.$emit("update", this.item);
    },
    onImageRemove(list) {
      this.$emit("image-remove", list);
    },
    onImageUpload(url) {
      this.$emit("image-upload", url);
    },
    onImageUploading(file) {
      this.$emit("image-uploading", file);
    },
    onTagsLoad({ data: tags }) {
      this.availableTags = tags;
      this.resetFilteredTags();

      if (this.preset) {
        this.item.tags = _.map(this.preset.tags, (hash) => {
          return _.find(this.availableTags, { hash });
        });

        this.getFilteredTags("");
      }

      this.tagsLoaded = true;

      this.$emit("ready", true);
    },
    onTagRemove() {
      this.getFilteredTags("");
    },
    resetFilteredTags() {
      this.filteredTags = this.availableTags;
    },
    getFilteredTags(text) {
      const selectedTagsHashes = _.map(this.item.tags, "hash");

      this.filteredTags = this.availableTags
        .filter((tag) => {
          return (
            !selectedTagsHashes.includes(tag.hash) &&
            tag.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
          );
        })
        .slice(0, 30);
    },
    getTagIcon(tag) {
      if (this.item.send_email && _.includes(["group", "course"], tag.type)) {
        return "email-outline";
      }
    },
    isUrl(string) {
      const prefixes = ["www.", "http://", "https://"];

      for (const prefix of prefixes) {
        if (
          string.startsWith(prefix) &&
          string.substring(prefix.length).length > 0
        ) {
          return true;
        }
      }

      return false;
    },
    onDebouncedTitleUpdate: _.debounce(async function (title) {
      return await this.onTitleUpdate(title);
    }, 500),
    async onTitleUpdate(title) {
      this.item.category = null;

      if (this.isUrl(title)) {
        this.$emit("ready", false);
        this.ogTagsLoading = true;

        const { data: ogTags } = await axios.get(`/api/news/og-tags`, {
          params: { url: title },
        });

        this.$emit("ready", true);
        this.ogTagsLoading = false;

        if (_.get(ogTags, "type") == "article") {
          this.item.og_tags = ogTags;
        }
      } else {
        this.item.og_tags = null;
      }

      this.updateArticleInMediaFlag();
    },
    updateArticleInMediaFlag() {
      if (this.item.category != "media") {
        this.item.category = null;
      }

      if (
        this.item.og_tags &&
        this.item.title.startsWith("https://fmp.msu.ru/smi/")
      ) {
        this.item.category = "media";
        this.item.tags = [];
      }
    },
  },
});
</script>

<style scoped lang="sass">
.vertical-checkbox
    padding-bottom: 4px
    .b-checkbox
        vertical-align: middle
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/Article.vue